export default "__VITE_ASSET__LV8gDyH$__"